interface StoreHours {
  menuDay: string;
  fromTime: string;
  toTime: string;
}

interface HoursDetailProps {
  schedule: StoreHours[];
  onClose: () => void;
}

const DAY_ORDER = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const formatTime = (time?: string): string => {
  if (!time) return "";
  const [hRaw, mRaw] = time.split(":").map(Number);
  const period = hRaw >= 12 ? "PM" : "AM";
  const hours12 = hRaw % 12 || 12;
  const minutes = mRaw < 10 ? `0${mRaw}` : `${mRaw}`;
  return `${hours12}:${minutes} ${period}`;
};

const HoursDetail = ({ schedule, onClose }: HoursDetailProps) => {
  const today = DAY_ORDER[new Date().getDay()];
  const grouped = (schedule || []).reduce<Record<string, StoreHours[]>>((acc, s) => {
    (acc[s.menuDay] ||= []).push(s);
    return acc;
  }, {});
  const days = DAY_ORDER.filter((d) => grouped[d]);

  return (
    <div className="detail">
      <div className="detail__head">
        <p className="detail__eyebrow">Visit us</p>
        <h2 className="detail__name">Hours</h2>
      </div>

      {days.length === 0 ? (
        <p className="menu-empty">No schedule available.</p>
      ) : (
        <ul className="hours-list">
          {days.map((day) => (
            <li key={day} className={day === today ? "is-today" : ""}>
              <span>
                {day}
                {day === today && <span className="today-pill">Today</span>}
              </span>
              <em />
              <span>
                {grouped[day]
                  .map((s) => `${formatTime(s.fromTime)} – ${formatTime(s.toTime)}`)
                  .join(", ")}
              </span>
            </li>
          ))}
        </ul>
      )}

      <button className="detail__close" onClick={onClose}>
        Close
      </button>
    </div>
  );
};

export default HoursDetail;
